import { InjectionToken } from "@angular/core";

export const SESSION_STORAGE = new InjectionToken<string>("Session storage");
